<div class="flex flex-col gap-medpace">
    <mds-divider />
    <div class="grid grid-cols-3 gap-medpace">
        <div>
            <h5 class="blackTitle">Date Requested</h5>
            <span>{{ dateRequested$ | async | dateFormat: dateOnly : 'local' | uppercase }}</span>
        </div>
        @let dateSubmitted = dateSubmitted$ | async;
        @if (dateSubmitted) {
            <div>
                <h5 class="blackTitle">Date Submitted</h5>
                <span>{{ dateSubmitted | dateFormat: dateOnly : 'local' }}</span>
            </div>
        }
    </div>
    <div class="grid grid-cols-3 gap-medpace">
        <mds-text-field
            appDisableMouseScroll
            id="AmountToAuthorizeField"
            data-cy="amountToAuthorizeField"
            [formCtrl]="formGrp().controls.requestedAmountInLocalCurrency"
            inputType="decimal"
            [decimalPlaces]="2"
            placeholder="Type here..."
            appearance="outline"
            [label]="requestedLabel()"
        ></mds-text-field>
        <mds-dropdown
            [filterable]="true"
            [closeOnPageScroll]="false"
            appearance="outline"
            label="Currency"
            placeholder="Select currency"
            [options]="(currencyOptions$ | async) ?? []"
            id="filterDropdown"
            [formCtrl]="formGrp().controls.currency"
        ></mds-dropdown>
    </div>
    <div class="grid grid-cols-3 gap-medpace">
        @if ((isInProcessOrHigherAndHasElevatedAccess$ | async) === true) {
            <mds-text-field
                appDisableMouseScroll
                id="AuthorizedAmountField"
                data-cy="authorizedAmountField"
                [formCtrl]="formGrp().controls.authorizedAmountInLocalCurrency"
                inputType="decimal"
                [decimalPlaces]="2"
                placeholder="Type here..."
                appearance="outline"
                [label]="authorizedLabel()"
            ></mds-text-field>
        }
        @if (elevatedAccess$ | async) {
            <mds-datepicker
                [formCtrl]="formGrp().controls.transactionDate"
                id="transactionDate"
                data-cy="requestTransactionDate"
                appearance="outline"
                label="Transaction Date"
                [placeholder]="'Select date'"
            ></mds-datepicker>

            <mds-dropdown
                [closeOnPageScroll]="false"
                [appearance]="'outline'"
                [label]="'Merchant'"
                [placeholder]="'Select merchant'"
                id="paymentMerchantDropdown"
                data-cy="paymentMerchantDropdown"
                [options]="(merchantTypes$ | async) ?? []"
                [formCtrl]="formGrp().controls.merchant"
            ></mds-dropdown>
            @if ((isInProcessOrHigherAndHasElevatedAccess$ | async) === true) {
                <div class="flex flex-row gap-medpace">
                    @if (authorizedAmountUSDChip()) {
                        <mds-chip
                            [chips]="authorizedAmountUSDChip()"
                            [chipListType]="'basic'"
                            [multiple]="true"
                        ></mds-chip>
                    }
                    @if (authorizedAmountPatientsCurrencyChip()) {
                        <mds-chip
                            [chips]="authorizedAmountPatientsCurrencyChip()"
                            [chipListType]="'basic'"
                            [multiple]="true"
                        ></mds-chip>
                    }
                </div>
            }
        }
    </div>

    @if ((isVoided$ | async) === true) {
        <div>
            <medpace-payment-request-deduction-edit [formGrp]="formGrp().controls.deduction" />
        </div>
    }
    @if ((isInProcessOrHigherAndHasElevatedAccess$ | async) === true) {
        <mds-textarea
            id="stipend-notes-field"
            [formCtrl]="formGrp().controls.notes"
            [label]="'Notes'"
            [appearance]="'outline'"
            [placeholder]="'Type here...'"
            [autoSize]="true"
            [cdkAutosizeMinRows]="4"
            [cdkAutosizeMaxRows]="8"
        />
    }
</div>
